import { render } from "./CartoesServicos.vue?vue&type=template&id=3a7a9899&scoped=true"
import script from "./CartoesServicos.vue?vue&type=script&lang=js"
export * from "./CartoesServicos.vue?vue&type=script&lang=js"

import "./CartoesServicos.vue?vue&type=style&index=0&id=3a7a9899&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7a9899"]])

export default __exports__